import { _ } from "libs";

import React from "react";
import { Form, Field } from "react-final-form";
import { Profile } from "../../types";
import CitySelect from "../forms/controls/citySelect";
import PhoneNumberInput, { formatPhoneNumber, parsePhoneNumber } from "../forms/controls/phoneNumberInput";

type Props = {
	onChange: Function;
	profile: Profile;
};

export function VerifyProfileForm({ onChange, profile }: Props) {
	return (
		<Form
			onSubmit={async ({ city, mobilePhone, country }: any, mutators) => {
				let cityValue;
				if (city) {
					if (city.hasOwnProperty("value")) {
						cityValue = city.value;
					}
					if (city.hasOwnProperty("country")) {
						country = city.country;
					}
				}
				await onChange({ city: cityValue ? cityValue : city, country: country, mobilePhone: mobilePhone });
			}}
			validate={(values: any) => {
				const errors: any = {};

				if (!values.city || 0 === values.city.length) {
					errors.city = _("validation.mustBeFilled");
				}

				if (!values.mobilePhone || !/^(\+\d{1,3})?\s*[\d,\s?]{5,}$/.test(values.mobilePhone)) {
					errors.mobilePhone = _("validation.mustBeFilled");
				}

				return errors;
			}}
			initialValues={{ ...profile }}
			render={({ handleSubmit, submitting, pristine, invalid, values }) => (
				<form onSubmit={handleSubmit} className="fullWidth">
					<label>{_("phoneNumber.heading")}</label>
					<Field name="mobilePhone" format={formatPhoneNumber} parse={parsePhoneNumber}>
						{({ input, meta, ...rest }) => (
							<div className="field phoneNumber">
								<PhoneNumberInput {...{ input, meta, ...rest }} country={values.country} />
								{meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<Field name="city">
						{({ input, meta, ...rest }) => (
							<div className="field medium">
								<label>{_("form.city.label")}</label>
								<div className="autosuggestText autosuggestCity">
									<CitySelect
										{...{ input, meta, ...rest }}
										getDisplayValue={(value) => {
											if (typeof value === "object") {
												return value.value;
											}
											return value;
										}}
									/>
								</div>
								{meta.error && <p className="error">{meta.error}</p>}
							</div>
						)}
					</Field>
					<div className="buttons">
						<button type="submit" className="button" disabled={submitting || invalid}>
							{_("saveBtn")}
						</button>
					</div>
				</form>
			)}
		/>
	);
}

export default VerifyProfileForm;
